import { onCellStandard } from '../../helpers/helpers'
import { DataSourceItem } from '../../shipments-page'
import { ShipmentColumn } from '../../types/column-types'

export const stampLengthColumn: ShipmentColumn = {
    dataIndex: ['stamp', 'length'],
    title: 'Д',
    width: 35,
    render: (v: number, r: DataSourceItem) =>
        r.withoutCutting ? r.virtualStamp?.length : (r.stamp?.length ?? v),
    onCell: onCellStandard,
}
